export default {
  users: state => state.users,
  user: state => state.user,
  userMe: state => state.userMe,
  role: (state) => state.userMe?.role,
  
  loading: state => state.loading,
  error: state => state.error,

  message: state => state.message,
  filters: state => state.filters,
  pagination: state => state.pagination,

  isEmpty: state => state.users.length === 0
}